import { Box, Breadcrumbs, BreadcrumbsProps } from '@mui/material';
import Typography from '../typography/typography';
import { Link } from 'react-router-dom';

interface BreadCrumbSlot {
	link?: string;
	label: string | JSX.Element;
	linkState?: any;
	onClick?: () => void;
}

interface PropsType extends BreadcrumbsProps {
	path: BreadCrumbSlot[];
}

const BreadCrumb = (props: PropsType) => {
	const { path } = props;

	return (
		<>
			<Breadcrumbs
				sx={{
					'& .MuiBreadcrumbs-separator': {
						color: 'theme.secondary.600'
					}
				}}>
				{path?.map((slot, index) => (
					<Box key={index}>
						{index < path?.length - 1 ? (
							// <Link
							// 	to={String(slot?.link) ?? undefined}
							// 	style={{ display: 'block' }}>
								<Typography
									type='s4'
									color='theme.secondary.600'
									weight='medium'
									component={slot?.link ? Link : undefined}
									to={String(slot?.link) ?? undefined}
									state={slot?.linkState}
									onClick={slot?.onClick} style={{ display: 'block' }}>
									{slot?.label}
								</Typography>
							// </Link>
						) : (
							<Typography
								type='s4'
								weight='medium'
								color='theme.secondary.1000'>
								{slot?.label}
							</Typography>
						)}
					</Box>
				))}
			</Breadcrumbs>
		</>
	);
};

export { BreadCrumb };
export default BreadCrumb;
